module.exports = RightSidebar;